import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
// import { provideServiceWorker } from '@angular/service-worker'; // TODO:pwa uncomment when ready to enable
import { Adjust } from '@awesome-cordova-plugins/adjust/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';
import { routes } from 'src/app/app.routes';
import { AuthConfigModule } from 'src/app/auth/auth-config.module';
import { CoreModule } from 'src/app/core/core.module';
import { isProd } from 'src/app/core/helpers/utils';
import { CustomModule } from 'src/app/custom/custom.module';
import { environment } from 'src/environments/environment';
import { register } from 'swiper/element/bundle';

addIcons(allIcons); // Import all ionicons once, otherwise will have to import each icon on every component it's used in
register();

if (isProd) {
  Sentry.init({
    environment: environment.name,
    dsn: 'https://352ee504ffabb9ecfd8b4b8bd043fcdb@o4510119215890432.ingest.de.sentry.io/4510119628046416',
    /* integrations: [Sentry.replayIntegration()], disabled because it's very limited number of replays (unless there's a paid plan)
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur. */
  });
}

export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function plugins() {
  return [InAppBrowser, Adjust];
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      ReactiveFormsModule,

      CoreModule.forRoot(),
      CustomModule.forRoot(),
      AuthConfigModule
    ),

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),

    provideIonicAngular({ backButtonText: '', backButtonIcon: 'assets/images/common/arrow-back.svg', swipeBackEnabled: false }),
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },

    ...plugins(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),

    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),

    /* // TODO:pwa uncomment when ready to enable
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }), */
  ],
};
